module.exports = __webpack_public_path__ + "img/close.fe96f61d.svg";